// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10

import React, { useEffect,useState,useMemo } from "react";
import { Modal} from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field,useField} from "formik";
import * as Yup from "yup";
import {useCustomersUIContext} from "../CustomersUIContext"
import {
  Input,
  Select,
  // DatePickerField,
} from "../../../../../../_metronic/_partials/controls";
import { listCity} from "../../../_redux/city/cityCrud";

  // Customers Redux state

// Validation schema
const CustomerEditSchema = Yup.object().shape({
  area: Yup.string()
    .min(1, "Minimum 1 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Area is required"),

    
});
export function CustomerEditForm({
  saveCustomer,
  customer,
  actionsLoading,
  onHide,
  areas,
  countries,
   citylist


  
}) {

  const [countryId,setCountryId]=useState("");
  const [cities,setCities]=useState([...citylist]);
  const [cityId,setCityId]=useState("");
  const onOptionChangeHandler=async (e)=>{

    console.log("setting countryId",e.target.value);
    setCountryId(e.target.value);

    listCities(e.target.value);
  };
  const oncityChangeHandler=async (e)=>{

    console.log(e.target.value);
    setCityId(e.target.value);
  
  };
const listCities=(countryId)=>{
    console.log(countryId);
    listCity({countryId:countryId}).then(result=>{
      setCities([...result.data.data]);
      console.log(cities[0])

    })
  
}
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={customer}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          console.log('val21',values);
          values.countryId=countryId===""?countries[0]._id:countryId;
          values.cityId=cityId===""?cities[0]._id:cityId;
          console.log('vali2',values)
          saveCustomer(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Field
                      name="area"
                      component={Input}
                      placeholder="Area Name"
                      label="Area Name"
                    />
                  </div>
                  {/* Last Name */}
                  <div className="col-lg-4">
                  <label for="countryId">Choose Country:</label>
                   <select
        name="countryId"
        value={countries._id}
        onChange={onOptionChangeHandler}
        style={{ display: "block" }}
      >
         {countries.map((m)=>{
          return(<option value={m._id} label={m.name}>{m.name}</option>)
         })}
      
      </select>
                  
                  </div>
                  <div className="col-lg-4">
                  <label for="cityId">Choose City:</label>
                  <select
        name="cityId"
        defaultChecked={cities[1]}
        value={cities._id}
        onChange={oncityChangeHandler}
        style={{ display: "block" }}
      >
         {cities.map((m)=>{
          return(<option value={m._id} label={m.name}>{m.name}</option>)
         })}
      
      </select>
                  </div>
                </div>
               
                 
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
